import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setTalkingPoints } from './talking-points.actions';
export const talkingPoints = createReducer({}, on(setTalkingPoints, (state, action) => {
    return action.talkingPoints;
}), on(resetAllCustomPdfReportItems, () => {
    return {};
}));
